import { render, staticRenderFns } from "./DDFriendlyLinks.vue?vue&type=template&id=000c4740&"
import script from "./DDFriendlyLinks.vue?vue&type=script&lang=js&"
export * from "./DDFriendlyLinks.vue?vue&type=script&lang=js&"
import style0 from "./DDFriendlyLinks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports